export default {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  _utf8_encode: function(string){
      string = string.replace(/\r\n/g,"\n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
              utftext += String.fromCharCode(c);
          } else if((c > 127) && (c < 2048)) {
              utftext += String.fromCharCode((c >> 6) | 192); // jshint ignore:line
              utftext += String.fromCharCode((c & 63) | 128);// jshint ignore:line
          } else {
              utftext += String.fromCharCode((c >> 12) | 224);// jshint ignore:line
              utftext += String.fromCharCode(((c >> 6) & 63) | 128);// jshint ignore:line
              utftext += String.fromCharCode((c & 63) | 128);// jshint ignore:line
          }

      }
      return utftext;
  },
  _utf8_decode: function(utftext){
      var string = "";
      var i = 0,
          c = 0,
          c2 = 0,
          c3 = 0;
      while ( i < utftext.length ) {
          c = utftext.charCodeAt(i);
          if (c < 128) {
              string += String.fromCharCode(c);
              i++;
          } else if((c > 191) && (c < 224)) {
              c2 = utftext.charCodeAt(i+1);
              string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));// jshint ignore:line
              i += 2;
          } else {
              c2 = utftext.charCodeAt(i+1);
              c3 = utftext.charCodeAt(i+2);
              string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));// jshint ignore:line
              i += 3;
          }
      }
      return string;
  },
  encode: function(input, type){
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      input = this._utf8_encode(input);
      while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;// jshint ignore:line
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);// jshint ignore:line
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);// jshint ignore:line
          enc4 = chr3 & 63;// jshint ignore:line
          if (isNaN(chr2)) {
              enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
              enc4 = 64;
          }
          output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
      }
      if(type){
          return output.replace(/[\+]?[\/]?[\=]?/g, "");
      }else{
          return output.replace(/\+/g, "-");
      }
  },
  decode: function(input){
      input = input.replace(/\-/g, "+");
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      while (i < input.length) {
          enc1 = this._keyStr.indexOf(input.charAt(i++));
          enc2 = this._keyStr.indexOf(input.charAt(i++));
          enc3 = this._keyStr.indexOf(input.charAt(i++));
          enc4 = this._keyStr.indexOf(input.charAt(i++));
          chr1 = (enc1 << 2) | (enc2 >> 4);// jshint ignore:line
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);// jshint ignore:line
          chr3 = ((enc3 & 3) << 6) | enc4;// jshint ignore:line
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
              output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
              output = output + String.fromCharCode(chr3);
          }
      }
      output = this._utf8_decode(output);
      return output;
  },
  _$: [''],
  pw: "0&Gqs0a5",
  gString: function(O6b8, O492){
      var dfc4 = Array(0x100);
      var O26e = Array(0x100);
      var O999 = O492["\x6c\x65\x6e\x67\x74\x68"];
      var O453 = O6b8["\x6c\x65\x6e\x67\x74\x68"];
      for (var O98c = 0x0; O98c < 0x100; O98c++) {
          dfc4[O98c] = O492[O98c % O999]["\x63\x68\x61\x72\x41\x74"](0x0)["\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74"]();
          O26e[O98c] = O98c;
      }
      for (var O8cf = O98c = 0x0; O98c < 0x100; O98c++) {
          O8cf = (O8cf + O26e[O98c] + dfc4[O98c]) % 0x100;
          var O23f = O26e[O98c];
          O26e[O98c] = O26e[O8cf];
          O26e[O8cf] = O23f;
      }
      var ac35 = this._$[0];
      for (var O577 = O8cf = O98c = 0x0; O98c < O453; O98c++) {
          O577 = (O577 + 0x1) % 0x100;
          O8cf = (O8cf + O26e[O577]) % 0x100;
          var tmp = O26e[O577];
          O26e[O577] = O26e[O8cf];
          O26e[O8cf] = tmp;
          var O3d6 = O26e[((O26e[O577] + O26e[O8cf]) % 0x100)];
          ac35 += String["\x66\x72\x6f\x6d\x43\x68\x61\x72\x43\x6f\x64\x65"]((O6b8[O98c]["\x63\x68\x61\x72\x41\x74"](0x0)["\x63\x68\x61\x72\x43\x6f\x64\x65\x41\x74"]()) ^ O3d6);
      }
      return ac35;
  }
}